export default __webpack_public_path__ + "static/stocktonkatie-b29886b6bc0ed3951fd5a91269d083c7.jpg";